<template>
    <div class="container">
        <div class="department_function" v-if="detail&&detail.length">
            <ul class="depart_fun_list">
                <li class="depart_fun_item" v-for="item in detail" :key="item.id">
                    <dl class="depart_fun_item_content">
                        <dt class="depart_name dflex psr">
                            <div class="namesfor"><span class="zhao di">招</span><span class="name">{{item.title}}</span></div>
                            <label><input type="checkbox" v-model="openArr" class="psa" :value="item.id"><span class="openbox cp" :class="{'active': isopen(item.id)}">{{isopen(item.id)?'收起':'展开'}}</span></label>
                        </dt>
                        <dd class="rela_infor oh" :class="{'active': isopen(item.id)}">
                            <div class="sort_case">
                                <div class="case_title">岗位职责：</div>
                                <div class="fun_des" v-html="item.duties">
                                    <!-- <p>{{item.duties}}</p> -->
                                </div>
                            </div>
                            <div class="sort_case">
                                <div class="case_title">岗位要求：</div>
                                <div class="fun_des" v-html="item.claim">
                                    <!-- <p>{{item.claim}}</p> -->
                                </div>
                            </div>
                            <div class="sort_case">
                                <div class="case_title">其他说明：</div>
                                <div class="fun_des" v-html="item.other">
                                    <!-- <p>{{item.other}}</p> -->
                                </div>
                            </div>
                        </dd>
                    </dl>
                </li>
            </ul>
        </div>
        <template v-else>
            <nothing></nothing>
        </template>
    </div>
</template>
<script>
import { getJob} from '~/until/http.js'
import nothing from '~/components/nothing.vue'
export default {
    data (){
        return {
            openArr: []
        }
    },
    computed: {
        isopen (n){
            return (n)=>{
                return this.openArr.indexOf(n) > -1? true: false
            }
        }
    },
    components: {
        nothing
    },
    async asyncData({isDev, route, store, env, params, query, req, res, redirect, error}) {
        let cont = await getJob(params.subid)
        return {
            detail: cont.content
        }
    },
    mounted(){
        getJob(this.$route.params.subid).then(res => {
            console.log(res)
            
        })
    }
}
</script>
<style lang="scss" scoped>
.rela_infor{
    max-height: 62px;
    position: relative;
    &.active{
        max-height: 500px;
        &:after{
            content: ''
        }
    }
    &:after{
        content: '...';
        color: #555;
        position: absolute;
        right: 0;
        bottom: 0;
    }
}
.case_title{
    color: #333;
    font-weight: bold;
    padding-top: 15px;
}
.zhao{
    width: 20px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    background-color: #F7941D;
    margin-right: 7px;
}
.openbox{
    padding-right: 10px;
    font-size: 12px;
    color: #999;
    line-height: 20px;
    background: url(~assets/images/collapse_icon2.png) no-repeat right center;
    &.active{
        color: #F7941D;
        background: url(~assets/images/collapse_icon1.png) no-repeat right center;
    }
}
.depart_fun_item{
    margin-top: 20px;
    padding: 15px 20px;
    background-color: #F9F7F7;
    border: 1px solid #F1F1F1;
}
.rela_infor{
    transition: all 0.3s;
}
.fun_des{
    color: #555;
    padding-top: 5px;
    line-height: 22px;
}
.department_function{
    padding: 0 40px;
    padding-bottom: 30px;
}
.depart_name{
    justify-content: space-between;
    align-items: center;
    input.psa{
        clip: rect(0,0,0,0);
    }
    .namesfor{
        color: #333;
        font-weight: bold;
        line-height: 20px;
    }
}
</style>
